import React from 'react';

import { Link, styled, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

import { FONTSIZE_S } from 'theme/typography';
import globalMessages from 'translations/messages/global-messages';
import { privacyPolicyUrl, termsOfServiceUrl } from 'utils/constants';

const Link_PrivacyTerms = styled(Link)(({ theme }) => ({
  margin: theme.spacing(0, 1),
  color: 'inherit',
  padding: 0,
  textDecorationColor: 'inherit',
  fontSize: FONTSIZE_S,
}));

const LoginPrivacy = () => {
  const intl = useIntl();
  return (
    <Typography variant="bodyLight">
      {intl.formatMessage(globalMessages.privacy_policy_terms_1)}
      <Link_PrivacyTerms href={privacyPolicyUrl} target="_blank">
        {intl.formatMessage(globalMessages.privacy_policy_terms_2)}
      </Link_PrivacyTerms>
      {intl.formatMessage(globalMessages.privacy_policy_terms_3)}
      <Link_PrivacyTerms href={termsOfServiceUrl} target="_blank">
        {intl.formatMessage(globalMessages.general_terms_and_conditions).toLowerCase()}
      </Link_PrivacyTerms>
    </Typography>
  );
};

export default LoginPrivacy;
